import { render, staticRenderFns } from "./AbnormalContent.vue?vue&type=template&id=273ba794&"
import script from "./AbnormalContent.vue?vue&type=script&lang=js&"
export * from "./AbnormalContent.vue?vue&type=script&lang=js&"
import style0 from "./AbnormalContent.vue?vue&type=style&index=0&id=273ba794&prod&lang=css&"
import style1 from "./AbnormalContent.vue?vue&type=style&index=1&id=273ba794&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports